var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-container"},[_c('g-select',{attrs:{"popper-class":"lang-select-popper","size":"small","options":_vm.options},on:{"change":_vm.handleLangChange},model:{value:(_vm.$root.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$root.$i18n, "locale", $$v)},expression:"$root.$i18n.locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }